export default __webpack_public_path__ + "static/media/480_dummy2016-tattoo01-mobile-de.29113d44.png";